import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { YStack } from 'tamagui';

import { SensorGrid } from './components/SensorGrid';
import { TemperatureOverview } from './components/TemperatureOverview';
import { UnlockButton } from './components/UnlockButton';
import { LogoTimeDate } from '../../components/common/LogoTimeDate';
import { ThreeCardLayout } from '../../components/layouts/ThreeCardLayout';
import { useFirmwareContext } from '../../contexts/FirmwareContext';
import { ROUTE_PATHNAMES } from '../../routes/routeConstants';

export const LockScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tryUnlock } = useFirmwareContext();

  const onUnlock = async () => {
    const unlocked = await tryUnlock(null);
    if (!unlocked) {
      navigate(ROUTE_PATHNAMES.lockPinCode);
    }
    // Navigation to dashboard is handled automatically by Router when isLocked changes
  };

  return (
    <ThreeCardLayout
      left={<LogoTimeDate />}
      middle={
        <YStack
          flex={1}
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="stretch"
          gap="$12">
          <TemperatureOverview />
          <UnlockButton text={t('lock.tapToUnlock')} onUnlock={onUnlock} />
        </YStack>
      }
      right={<SensorGrid />}
    />
  );
};
